import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import {
  CONTACT_DATA,
  FORM_AUTO,
  FORM_BP,
  FORM_CONSUMO,
  FORM_MG,
  FORM_MG_NO_SHOP,
  HOLDER_DATA,
  INTERVINIENTE_1_CONTACT_DATA,
  INTERVINIENTE_2_CONTACT_DATA,
  INTERVINIENTE_3_CONTACT_DATA,
  INTERVINIENTE_4_CONTACT_DATA,
  PENDIENTES_DE_DATOS,
  REQUEST_MODE_EDIT,
  REQUEST_MODE_NEW,
  REQUEST_MODE_VIEW,
} from '@app/@core/constants/requests.constants';
import { CustomValidatorsService } from '@app/@shared/custom-validators/custom-validators.service';
import { CombosStore } from '@app/requests/combos-service/combos.store';
import { RequestsSaveSendStore } from '@app/requests/requests-save-send-service/requests-save-send.store';
import { ResponseDialogComponent } from '@app/@shared/dialogs/response/response-dialog.component';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { Participant, StatesFieldsFrontDTO } from '@app/requests/model/requests-model';
import { CommonDataDTO } from '@app/requests/model/combos-model';
import {
  ListarCodPostalDto,
  ListarViaDto,
  NormalizarDomicilioDto,
  NormalizarPoblacionDto,
  NormalizarViaDto,
  PFValidarEmailDto,
  ValidarTelefonoDto,
} from '@app/requests/model/geocode-model';
import { GeocodeStore } from '@app/requests/geocode-service/geocode.store';

const PHONE_FIELD = 'phone';
const NOPHONE = 'nophone';
const ADDITIONAL_PHONE_FIELD = 'additionalPhone';
const EMAIL = 'email';
const NOEMAIL = 'noemail';

@Component({
  selector: 'scf-contact-data',
  templateUrl: './contact-data.component.html',
  styleUrls: ['./contact-data.component.scss'],
})
export class ContactDataComponent implements OnInit, OnDestroy {
  @Input() mode: string = 'new';
  @Input() request: any = null;
  @Input() state: CommonDataDTO;
  @Input() public interviniente: Participant = null;
  @Input() public isAuto: boolean;
  @Input() public isConsumption: boolean;
  @Input() public isBP: boolean;
  @Input() public isMG: boolean;
  @Input() public isMgWithShopping: boolean;
  @Input() public numInterviniente: string = '1';
  @Input('operative') set operative(data: any) {
    if (data) {
      const index = this.interviniente ? INTERVINIENTE_1_CONTACT_DATA : CONTACT_DATA;

      if (data === 'EIC' && this.requestStore.listaFormulariosConsumo.includes(this.contactDataForm)) {
        this.requestStore.listaFormulariosConsumo[index] = null;
      } else if (data !== 'EIC' && !this.requestStore.listaFormulariosConsumo.includes(this.contactDataForm)) {
        this.requestStore.setFormularioConsumo(this.contactDataForm, index);
      }
    }
  }
  @Output() public changeContinueStatus = new EventEmitter<any>();
  @Output() public isFinishedLoading = new EventEmitter<any>();

  public contactDataForm: FormGroup;
  public formData: FormGroup;
  public checkedNoEmail: boolean = false;
  public checkedNoPhone: boolean = false;
  public isCheckContactDataEnabled: boolean = false;
  public optionalCodPostal: boolean = true;
  public codAddresSelected: CommonDataDTO;
  public codPoblacionSelected: CommonDataDTO;
  public showTrackType: boolean = true;
  public newAddress: string;
  public firstloadEdit: boolean = false;

  public townList: CommonDataDTO[] = [];
  public listPopulation: CommonDataDTO[] = [];
  public listPopulationSelect: CommonDataDTO[] = [];
  public listTypesVia: CommonDataDTO[] = [];
  public listTypesViaSelect: CommonDataDTO[] = [];
  public listVia: CommonDataDTO[] = [];
  public listViaSelect: CommonDataDTO[] = [];
  public errorNormalizarPoblacion: boolean = false;
  public errorNormalizarVia: boolean = false;
  public errorNormalizarDomicilio: boolean = false;
  private contactDataSubscription: Subscription;

  //PE_725 Fenix
  fieldsDisabled: StatesFieldsFrontDTO[];

  constructor(
    private formBuilder: FormBuilder,
    private requestStore: RequestsSaveSendStore,
    private combosStore: CombosStore,
    private customValidators: CustomValidatorsService,
    private translate: TranslateService,
    public dialog: MatDialog,
    private geocodeStore: GeocodeStore
  ) {}

  ngOnInit(): void {
    console.log('ngOnInit');
    this.contactDataForm = this.formBuilder.group({
      address: ['', [Validators.required, Validators.maxLength(50)]],
      number: ['', [Validators.required, Validators.maxLength(5), this.customValidators.validateNumber]],
      addressComplement: ['', Validators.maxLength(15)],
      floor: [
        '',
        [Validators.maxLength(2), this.customValidators.validateNumber, Validators.min(1), Validators.max(99)],
      ],
      door: ['', [Validators.max(9), this.customValidators.isAlphanumericValid]],
      postalCode: [
        '',
        [
          Validators.required,
          Validators.maxLength(5),
          Validators.minLength(5),
          this.customValidators.validatePostalCode,
        ],
      ],
      //trackType: ['', Validators.required], CTI
      town: ['', Validators.required],
      phone: ['', [Validators.required, this.customValidators.isTelephoneValid]],
      nophone: [''],
      additionalPhone: ['', this.customValidators.islandlineValid],
      email: ['', [Validators.required, this.customValidators.validateEmail]],
      noemail: [''],
    });

    //{ value: '', disabled: true } deshabilitar campos con CTI

    if (
      (this.requestStore.getMarcaFormulario() === FORM_AUTO ||
        this.requestStore.getMarcaFormulario() === FORM_CONSUMO) &&
      !this.interviniente
    ) {
      this.contactDataForm.valueChanges.subscribe(() => {
        this.requestStore.setContactDataForm(this.contactDataForm);
      });
    }

    this.contactDataForm.statusChanges.subscribe(() => {
      // console.log("subscribe, interviniente: ", this.interviniente);
      // console.log("form email: ", this.contactDataForm.controls.email.value);
      // console.log("noemail: ", this.contactDataForm.controls.noemail.value);
      this.emitStatusForm();
    });

    this.formData = this.contactDataForm;

    if (this.requestStore.getMarcaFormulario() === FORM_BP) {
      this.requestStore.setFormularioBonpreu(this.contactDataForm, CONTACT_DATA);
    } else if (this.requestStore.getMarcaFormulario() === FORM_MG_NO_SHOP) {
      this.requestStore.setFormularioMangoNoShopping(this.contactDataForm, CONTACT_DATA);
    } else if (this.requestStore.getMarcaFormulario() === FORM_MG) {
      this.requestStore.setFormularioMg(this.contactDataForm, CONTACT_DATA);
    } else if (
      this.requestStore.getMarcaFormulario() === FORM_CONSUMO ||
      this.requestStore.getMarcaFormulario() === FORM_AUTO
    ) {
      let isConsumo = this.requestStore.getMarcaFormulario() === FORM_CONSUMO;
      if (this.interviniente) {
        switch (this.interviniente.id) {
          case 1:
            isConsumo
              ? this.requestStore.setFormularioConsumo(this.contactDataForm, INTERVINIENTE_1_CONTACT_DATA)
              : this.requestStore.setFormularioAutos(this.contactDataForm, INTERVINIENTE_1_CONTACT_DATA);
            break;
          case 2:
            this.requestStore.setFormularioAutos(this.contactDataForm, INTERVINIENTE_2_CONTACT_DATA);
            break;
          case 3:
            this.requestStore.setFormularioAutos(this.contactDataForm, INTERVINIENTE_3_CONTACT_DATA);
            break;
          case 4:
            this.requestStore.setFormularioAutos(this.contactDataForm, INTERVINIENTE_4_CONTACT_DATA);
            break;
          default:
            console.error('Interviniente Not found!');
        }
        this.requestStore.isCheckContactData$.subscribe((value) => (this.isCheckContactDataEnabled = value));
      } else {
        isConsumo
          ? this.requestStore.setFormularioConsumo(this.contactDataForm, CONTACT_DATA)
          : this.requestStore.setFormularioAutos(this.contactDataForm, CONTACT_DATA);

        this.contactDataForm.valueChanges.subscribe(() => {
          this.contactDataForm.controls.address.valid &&
          this.contactDataForm.controls.number.valid &&
          this.contactDataForm.controls.addressComplement.valid &&
          this.contactDataForm.controls.floor.valid &&
          this.contactDataForm.controls.door.valid &&
          this.contactDataForm.controls.postalCode.valid &&
          this.contactDataForm.controls.town.valid
            ? this.requestStore.setCheckContactData(true)
            : this.requestStore.setCheckContactData(false);
        });
      }
    }

    this.requestStore.valueCheckVideoSelfing.subscribe((data) => {
      console.log(this.requestStore.getVideoSelfingID());
      if (this.interviniente != null) {
        if (data) {
          this.contactDataForm.controls.noemail.setValue(false);
          this.contactDataForm.controls.noemail.disable();
          this.contactDataForm.controls.nophone?.setValue(false);
          this.contactDataForm.controls.nophone?.disable();
          this.noPhoneChange();
          this.noemailChange();
        } else {
          if (this.requestStore.getVideoSelfingID() == 'ENABLED') {
            this.contactDataForm.controls.noemail.enable();
            this.contactDataForm.controls.nophone?.enable();
          } else if (this.requestStore.getVideoSelfingID() == 'X') {
            this.contactDataForm.controls.noemail.enable();
            this.contactDataForm.controls.nophone?.enable();
          } else if (this.requestStore.getVideoSelfingID() == 'IMAX' || this.requestStore.getVideoSelfingID() == 'O') {
            this.contactDataForm.controls.noemail.enable();
            this.contactDataForm.controls.nophone?.enable();
          } else if (
            this.requestStore.getVideoSelfingID() != 'DISABLED' &&
            this.requestStore.getVideoSelfingID() != 'DISABLED_X'
          ) {
            if ((this.firstloadEdit = false)) {
              this.contactDataForm.controls.noemail.setValue(false);
              this.contactDataForm.controls.noemail.enable();
              this.contactDataForm.controls.nophone?.setValue(false);
              this.contactDataForm.controls.nophone?.enable();
            }
          } else {
            this.contactDataForm.controls.noemail.enable();
            this.contactDataForm.controls.nophone?.enable();
          }
        }
      } else {
        if (data && this.requestStore.getVideoSelfingID() == 'S') {
          this.contactDataForm.controls.noemail.setValue(false);
          this.contactDataForm.controls.noemail.disable();
          this.contactDataForm.controls.nophone?.setValue(false);
          this.contactDataForm.controls.nophone?.disable();
        } else if (this.requestStore.getVideoSelfingID() == 'IMAX' || this.requestStore.getVideoSelfingID() == 'O') {
          this.contactDataForm.controls.noemail.enable();
          this.contactDataForm.controls.nophone?.enable();
        } else if (
          this.requestStore.getVideoSelfingID() != 'DISABLED' &&
          this.requestStore.getVideoSelfingID() != 'DISABLED_X'
        ) {
          this.contactDataForm.controls.noemail.enable();
          this.contactDataForm.controls.nophone.enable();
        }
      }

      // PE_725 Fenix se mueve del afterViewInit a la respuesta del observable de VS
      if (
        this.mode === REQUEST_MODE_EDIT &&
        this.state.id !== PENDIENTES_DE_DATOS &&
        this.request !== null &&
        this.request.fieldsDisable !== null
      ) {
        this.fieldsDisabled = this.request.fieldsDisable;
        this.disableFieldsByCore();
      }

      if (
        this.mode === REQUEST_MODE_EDIT &&
        this.state.id !== PENDIENTES_DE_DATOS &&
        this.requestStore.getVideoSelfingID() === 'U'
      ) {
        this.contactDataForm.controls.noemail.disable();
        this.contactDataForm.controls.nophone.disable();
      }

      if (this.mode === REQUEST_MODE_VIEW) {
        this.contactDataForm.disable();
      }
    });
  }

  ngOnDestroy(): void {
    this.interviniente = null;
    if (this.contactDataSubscription) {
      this.contactDataSubscription.unsubscribe();
    }
  }

  ngAfterViewInit() {
    if (this.mode === REQUEST_MODE_VIEW) {
      this.setValuesToForm();
      if (this.state.id !== PENDIENTES_DE_DATOS) {
        this.contactDataForm.disable();
      }
    } else if (this.mode === REQUEST_MODE_EDIT) {
      this.setValuesToForm();
      this.firstloadEdit = true;
      this.contactDataForm.markAllAsTouched();
    }
    this.emitStatusForm();
    this.isFinishedLoading.emit({ formID: CONTACT_DATA, value: true });
  }

  private emitStatusForm() {
    if (this.interviniente) {
      switch (this.interviniente.id) {
        case 1:
          this.changeContinueStatus.emit({ form: <FormGroup>this.contactDataForm, id: INTERVINIENTE_1_CONTACT_DATA });
          break;
        case 2:
          this.changeContinueStatus.emit({ form: <FormGroup>this.contactDataForm, id: INTERVINIENTE_2_CONTACT_DATA });
          break;
        case 3:
          this.changeContinueStatus.emit({ form: <FormGroup>this.contactDataForm, id: INTERVINIENTE_3_CONTACT_DATA });
          break;
        case 4:
          this.changeContinueStatus.emit({ form: <FormGroup>this.contactDataForm, id: INTERVINIENTE_4_CONTACT_DATA });
          break;
        default:
          console.error('Interviniente Not found!');
      }
    } else {
      this.changeContinueStatus.emit({ form: <FormGroup>this.contactDataForm, id: CONTACT_DATA });
    }
  }

  // eliminar con CTI
  updateTown(event: any): void {
    if (this.contactDataForm.controls.postalCode.valid) {
      this.updateComboTown(event.target.value);
    } else {
      this.contactDataForm.controls.town.setValue(undefined);
      this.townList = [];
    }
  }

  private updateComboTown(postalCode: string) {
    if (postalCode) {
      this.isFinishedLoading.emit({ formID: CONTACT_DATA, value: false });
      this.combosStore
        .loadComboTowns(postalCode)
        .then(
          (data) => {
            this.townList = data;
            this.contactDataForm.controls.town.setValue(this.townList[0].value);
          },
          (error) => {
            this.townList = [];
            this.contactDataForm.controls.town.setValue(undefined);
            console.log(error);
          }
        )
        .finally(() => {
          this.isFinishedLoading.emit({ formID: CONTACT_DATA, value: true });
        });
    }
  }
  copyFromHolder(checkbox: MatCheckboxChange) {
    if (checkbox.checked) {
      //TODO: check esta subscription
      this.contactDataSubscription = this.requestStore.contactDataForm$.subscribe((form: FormGroup) => {
        console.log('copying data...');
        this.formData = form;
      });
      this.updateCombos();
      this.updateComboTown(this.formData.controls.postalCode.value);
      this.disableCombos();
    } else {
      this.enableCombos();
    }
  }

  /**
   * Updates the current value of all inputs when checkbox is checked
   */
  updateCombos() {
    Object.keys(this.contactDataForm.controls).forEach((key) => {
      if (
        key !== PHONE_FIELD &&
        key !== NOPHONE &&
        key !== ADDITIONAL_PHONE_FIELD &&
        key !== EMAIL &&
        key !== NOEMAIL
      ) {
        this.contactDataForm.controls[key].setValue(this.formData.controls[key].value);
      }
    });
  }

  disableCombos() {
    Object.keys(this.contactDataForm.controls).forEach((key) => {
      if (
        key !== PHONE_FIELD &&
        key !== NOPHONE &&
        key !== ADDITIONAL_PHONE_FIELD &&
        key !== EMAIL &&
        key !== NOEMAIL
      ) {
        this.contactDataForm.controls[key].disable();
      }
    });
  }

  enableCombos() {
    Object.keys(this.contactDataForm.controls).forEach((key) => {
      if (key !== PHONE_FIELD && key !== ADDITIONAL_PHONE_FIELD && key !== EMAIL && key !== NOEMAIL) {
        this.contactDataForm.controls[key].reset();
        this.contactDataForm.controls[key].enable();
      }
    });
  }

  public noPhoneChange() {
    if (this.contactDataForm.controls.nophone.value) {
      this.showDialogNoPhone();
      if (
        this.interviniente == null &&
        this.requestStore.getVideoSelfingID() != undefined &&
        this.requestStore.getVideoSelfingID() != 'N' &&
        this.requestStore.getVideoSelfingID() != 'S' &&
        this.requestStore.getVideoSelfingID() != '' &&
        this.requestStore.getVideoSelfingID() != 'IMAX' &&
        this.mode !== REQUEST_MODE_EDIT &&
        this.state?.id !== PENDIENTES_DE_DATOS
      ) {
        this.requestStore.setVideoSelfingID('DISABLED');
      }
    } else {
      let phoneValue = '';
      phoneValue = this.contactDataForm.controls.phone?.value;
      this.contactDataForm.removeControl('phone');
      this.contactDataForm.addControl(
        'phone',
        new FormControl(phoneValue, [Validators.required, this.customValidators.isTelephoneValid])
      );
      if (
        this.interviniente == null &&
        this.requestStore.getVideoSelfingID() != undefined &&
        this.requestStore.getVideoSelfingID() != 'N' &&
        this.requestStore.getVideoSelfingID() != 'S' &&
        this.requestStore.getVideoSelfingID() != '' &&
        this.requestStore.getVideoSelfingID() != 'IMAX' &&
        !this.contactDataForm.controls.noemail.value &&
        this.mode !== REQUEST_MODE_EDIT &&
        this.state?.id !== PENDIENTES_DE_DATOS
      ) {
        this.requestStore.setVideoSelfingID('ENABLED');
      }
      let additionalPhoneValue = '';
      additionalPhoneValue = this.contactDataForm.controls.additionalPhone.value;
      this.contactDataForm.controls.additionalPhone.setValue(additionalPhoneValue);
      this.contactDataForm.controls.additionalPhone.setValidators([this.customValidators.islandlineValid]);
      this.contactDataForm.controls.additionalPhone.updateValueAndValidity();
    }
  }

  private showDialogNoPhone() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.data = {
      text: this.contactDataForm.controls.phone.value
        ? this.translate.instant('dialog.nophone.erase.text')
        : this.translate.instant('dialog.nophone.text'),
      icon: undefined,
      title: this.translate.instant('dialog.nophone.title'),
      buttonCancel: this.contactDataForm.controls.phone.value ? true : false,
    };

    const dialogNoPhone = this.dialog.open(ResponseDialogComponent, dialogConfig);
    dialogNoPhone.afterClosed().subscribe((accept: boolean) => {
      if (accept) {
        this.contactDataForm.controls.phone.disable();
        this.contactDataForm.controls.phone.setValue('');
        this.contactDataForm.controls.phone.setValidators(null);

        let phoneValue = '';
        phoneValue = this.contactDataForm.controls.additionalPhone.value;
        this.contactDataForm.controls.additionalPhone.setValue(phoneValue);
        this.contactDataForm.controls.additionalPhone.setValidators([
          Validators.required,
          this.customValidators.islandlineValid,
        ]);
        this.contactDataForm.controls.additionalPhone.updateValueAndValidity();
      } else {
        this.contactDataForm.controls.nophone.setValue(false);
        if (
          this.interviniente == null &&
          this.requestStore.getVideoSelfingID() != undefined &&
          this.requestStore.getVideoSelfingID() != 'N' &&
          this.requestStore.getVideoSelfingID() != 'S' &&
          this.requestStore.getVideoSelfingID() != '' &&
          this.requestStore.getVideoSelfingID() != 'IMAX' &&
          !this.contactDataForm.controls.noemail.value &&
          this.mode !== REQUEST_MODE_EDIT &&
          this.state?.id !== PENDIENTES_DE_DATOS
        ) {
          this.requestStore.setVideoSelfingID('ENABLED');
        }
      }
    });
  }

  public noemailChange() {
    if (this.contactDataForm.controls.noemail.value) {
      this.showDialogNoEmail();
      console.log(this.requestStore.getVideoSelfingID());
      if (
        this.interviniente == null &&
        this.requestStore.getVideoSelfingID() != undefined &&
        this.requestStore.getVideoSelfingID() != 'N' &&
        this.requestStore.getVideoSelfingID() != 'S' &&
        this.requestStore.getVideoSelfingID() != '' &&
        this.requestStore.getVideoSelfingID() != 'IMAX' &&
        this.mode !== REQUEST_MODE_EDIT &&
        this.state?.id !== PENDIENTES_DE_DATOS
      ) {
        this.requestStore.setVideoSelfingID('DISABLED');
      }
    } else {
      let emailValue = '';
      console.log(this.requestStore.getVideoSelfingID());
      if (
        this.interviniente == null &&
        this.requestStore.getVideoSelfingID() != undefined &&
        this.requestStore.getVideoSelfingID() != 'N' &&
        this.requestStore.getVideoSelfingID() != 'S' &&
        this.requestStore.getVideoSelfingID() != '' &&
        this.requestStore.getVideoSelfingID() != 'IMAX' &&
        !this.contactDataForm.controls.nophone.value &&
        this.mode !== REQUEST_MODE_EDIT &&
        this.state?.id !== PENDIENTES_DE_DATOS
      ) {
        this.requestStore.setVideoSelfingID('ENABLED');
      }
      emailValue = this.contactDataForm.controls.email?.value;
      this.contactDataForm.removeControl('email');
      this.contactDataForm.addControl(
        'email',
        new FormControl(emailValue, [Validators.required, this.customValidators.validateEmail])
      );
    }
  }

  private showDialogNoEmail() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.data = {
      text: this.contactDataForm.controls.email.value
        ? this.translate.instant('dialog.noemail.erase.text')
        : this.translate.instant('dialog.noemail.text'),
      icon: undefined,
      title: this.translate.instant('dialog.noemail.title'),
      buttonCancel: this.contactDataForm.controls.email.value ? true : false,
    };

    const dialogNoEmail = this.dialog.open(ResponseDialogComponent, dialogConfig);
    dialogNoEmail.afterClosed().subscribe((accept: boolean) => {
      if (accept) {
        this.contactDataForm.controls.email.setValue('');
        this.contactDataForm.controls.email.disable();
        this.contactDataForm.controls.email.setValidators(null);
      } else {
        this.contactDataForm.controls.noemail.setValue(false);
        if (
          this.interviniente == null &&
          this.requestStore.getVideoSelfingID() != undefined &&
          this.requestStore.getVideoSelfingID() != 'N' &&
          this.requestStore.getVideoSelfingID() != 'S' &&
          this.requestStore.getVideoSelfingID() != '' &&
          this.requestStore.getVideoSelfingID() != 'IMAX' &&
          !this.contactDataForm.controls.nophone.value &&
          this.mode !== REQUEST_MODE_EDIT &&
          this.state?.id !== PENDIENTES_DE_DATOS
        ) {
          this.requestStore.setVideoSelfingID('ENABLED');
        }
      }
    });
  }

  setValuesToForm() {
    if (this.request) {
      this.contactDataForm.controls.number.setValue(
        this.request.addressNumber === '0' ? '' : this.request.addressNumber
      );
      this.contactDataForm.controls.addressComplement.setValue(this.request.comDom);
      this.contactDataForm.controls.floor.setValue(this.request.floor === '0' ? '' : this.request.floor);
      this.contactDataForm.controls.door.setValue(this.request.door === '0' ? '' : this.request.door);
      this.contactDataForm.controls.postalCode.setValue(this.request.postcode);
      this.contactDataForm.controls.address.setValue(this.request.nameAddress);
      this.contactDataForm.controls.town.setValue(this.request.town);

      if (!this.isBP) {
        this.contactDataForm.controls.phone.setValue(this.request.mobileTel !== '0' ? this.request.mobileTel : '');
      } else {
        this.contactDataForm.controls.phone.setValue(this.request.houseTel !== '0' ? this.request.houseTel : '');
      }

      if (!this.isBP) {
        this.contactDataForm.controls.additionalPhone.setValue(
          this.request.houseTel !== '0' ? this.request.houseTel : ''
        );
        if (this.isMG && !this.isMgWithShopping) {
          this.contactDataForm.controls.phone.setValue(
            this.request.houseTel === '0'
              ? this.request.mobileTel === '0'
                ? ''
                : this.request.mobileTel
              : this.request.houseTel
          );
        } else {
          this.contactDataForm.controls.phone.setValue(
            this.request.mobileTel === '0'
              ? this.request.houseTel === '0'
                ? ''
                : this.request.houseTel
              : this.request.mobileTel
          );
        }
      } else {
        this.contactDataForm.controls.phone.setValue(
          this.request.houseTel === '0'
            ? this.request.mobileTel === '0'
              ? ''
              : this.request.mobileTel
            : this.request.houseTel
        );
      }

      if (this.request.mobileTel !== '0' && this.request.houseTel !== '0') {
        if (!this.isBP) {
          if (this.isMG && !this.isMgWithShopping) {
            this.contactDataForm.controls.additionalPhone.setValue(this.request.mobileTel);
          } else {
            this.contactDataForm.controls.additionalPhone.setValue(this.request.houseTel);
          }
        } else {
          this.contactDataForm.controls.additionalPhone.setValue(this.request.mobileTel);
        }
      } else {
        this.contactDataForm.controls.additionalPhone.setValue('');
      }

      this.controlNoMovilNoEmail();
    }
  }

  numberOnly(event: any, element: any): boolean {
    const inputForm = typeof element === 'string' ? element : element?.getAttribute('formControlName');
    let value = this.contactDataForm.controls[inputForm].value;

    return this.customValidators.numberOnly(event.which ? event.which : event.keyCode, value);
  }

  noSpaces(value: any, element: any) {
    const inputForm = typeof element === 'string' ? element : element?.getAttribute('formControlName');
    let inputValue = typeof value === 'string' ? value : value?.target.value;

    const valueWithoutSpaces = inputValue.trim();
    this.contactDataForm.controls[inputForm].setValue(valueWithoutSpaces);
  }

  alphanumericHyphenBackslash(event: any, element: any): boolean {
    const inputForm = typeof element === 'string' ? element : element?.getAttribute('formControlName');
    let value = this.contactDataForm.controls[inputForm].value;

    return this.customValidators.alphanumericHyphenBackslash(event.which ? event.which : event.keyCode, value);
  }

  alphanumericOnly(event: any, element: any): boolean {
    const inputForm = typeof element === 'string' ? element : element?.getAttribute('formControlName');
    let value = this.contactDataForm.controls[inputForm].value;

    return this.customValidators.alphanumericOnly(event.which ? event.which : event.keyCode, value);
  }

  alphanumericAndSpecialCharacters(value: any, element: any) {
    console.log(this.contactDataForm.controls.additionalPhone);
    const inputForm = typeof element === 'string' ? element : element?.getAttribute('formControlName');
    let inputValue = typeof value === 'string' ? value : value?.target.value;
    this.contactDataForm.controls[inputForm].setValue(
      this.customValidators.validateAlphanumericAndSpecialChars(inputValue)
    );
  }

  onMobilePhoneBlur(value: any, element: any) {
    this.alphanumericAndSpecialCharacters(value, element);
    if (this.contactDataForm.controls.phone.errors?.telephoneInvalid) {
      this.contactDataForm.controls.phone.setValue('');
    }

    //validar si está repetido
    if (this.requestStore.checkDuplicatedPhone()) {
      const dialogConfig = new MatDialogConfig();

      dialogConfig.data = {
        text: this.translate.instant('dialog.mobile.repeated.error'),
        icon: undefined,
        title: this.translate.instant('dialog.mobile.repeated.title'),
        buttonCancel: false,
      };

      const dialogPhoneDuplicated = this.dialog.open(ResponseDialogComponent, dialogConfig);

      this.contactDataForm.controls.phone.setValue('');
    } else {
      // Servicio CTI
      //this.checkValidarPhone(value);
    }
  }

  controlNoMovilNoEmail() {
    if (this.request.noEmail) {
      this.contactDataForm.removeControl('email');
      this.contactDataForm.addControl('email', new FormControl({ value: '', disabled: true }));
    }

    if (this.request.noMobile) {
      this.contactDataForm.removeControl('phone');
      this.contactDataForm.addControl('phone', new FormControl({ value: '', disabled: true }));
      this.contactDataForm.removeControl('additionalPhone');
      this.contactDataForm.addControl(
        'additionalPhone',
        new FormControl(this.request.houseTel, [Validators.required, this.customValidators.islandlineValid])
      );
      if (this.mode === REQUEST_MODE_VIEW) {
        this.contactDataForm.controls.additionalPhone.disable();
      }
    }

    if (this.request.noEmail || this.request.noMobile) {
      this.requestStore.setVideoSelfingID('DISABLED_X');
    }

    this.contactDataForm.controls.noemail?.setValue(this.request.noEmail);
    this.contactDataForm.controls.nophone?.setValue(this.request.noMobile);
    this.contactDataForm.controls.email.setValue(this.request.email);

    this.firstloadEdit = false;
  }

  private disableFieldsByCore() {
    if (this.fieldsDisabled !== null && this.fieldsDisabled !== undefined) {
      const form = this.contactDataForm;
      this.fieldsDisabled.forEach((field) => {
        const toDisable = form.get(field.campoName);
        if (toDisable !== null && toDisable !== undefined) {
          toDisable.disable();
        }
      });
    }
  }
}
